import React from 'react';

import { PageId } from 'utils/ubi/pageId';
import assemblePath from 'utils/assemblePath';

import InternalLink, { HrefFunction, LinkProps } from './InternalLink';

const homeLinkBuilder: HrefFunction = (market, verticalParam) => assemblePath(market, verticalParam);

const HomeLink = ({ ...props }: LinkProps) => (
  <InternalLink toPage={PageId.Home} hrefFun={homeLinkBuilder} {...props} />
);

export default HomeLink;
